<template>
  <div class="table-responsive">
    <table class="table">
      <tbody>
        <tr>
          <td :class="smallTextClass">{{ labels.stockCode }}</td>
          <td class="prop-value" :class="smallTextClass">{{ item?.sc }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.stockName }}</td>
          <td v-if="isBulgarian" class="prop-value" :class="smallTextClass">{{ item?.nBG ? item?.nBG : item?.nEN }}</td>
          <td v-if="isEnglish" class="prop-value" :class="smallTextClass">{{ item?.nEN }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.exchange }}</td>
          <td class="prop-value" :class="smallTextClass">{{ item?.ex || exchangeName }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.segment }}</td>
          <td class="prop-value" :class="smallTextClass">{{ item?.sgm }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.instrumentType }}</td>
          <td class="prop-value" :class="smallTextClass">{{ stockTypeResolver(item?.stid) }}</td>
        </tr>
        <tr>
          <td v-if="2 === item?.stid" :class="smallTextClass">{{ labels.faceValue }}</td>
          <td v-else :class="smallTextClass">{{ labels.numberOfShares }}</td>
          <td class="prop-value" :class="smallTextClass">{{ parseNumber(positionsAmountResolver(item), positionAmountDecimals) }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.averagePrice }}</td>
          <td v-if="2 !== item?.stid" class="prop-value" :class="smallTextClass">{{ formatPrice(item?.ap, item?.cc).replace(' ', '&nbsp;') }}</td>
          <td v-else class="prop-value" :class="smallTextClass">{{ formatPrice(item?.ap, '%').replace(' ', '&nbsp;') }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.marketPrice }}</td>
          <td v-if="2 !== item?.stid" class="prop-value" :class="smallTextClass">{{ formatPrice(marketUnitPrice, item?.cc).replace(' ', '&nbsp;') }}</td>
          <td v-else class="prop-value" :class="smallTextClass">{{ formatPrice(marketUnitPrice, '%').replace(' ', '&nbsp;') }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.position }}</td>
          <td class="prop-value" :class="smallTextClass">{{ formatPrice(marketPrice, item?.cc).replace(' ', '&nbsp;') }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.return }}</td>
          <td class="prop-value" :class="[smallTextClass, returnClass]">{{ returnPrefix }}{{ parseNumber(returnValue) }}</td>
        </tr>
        <tr>
          <td v-if="isBulgarian" :class="smallTextClass">{{ labels.return }}&nbsp;%</td>
          <td v-else :class="smallTextClass">%{{ labels.return }}</td>
          <td class="prop-value" :class="[smallTextClass, returnPercentClass]">{{ returnPercentPrefix }}{{ parseNumber(returnPercent) }}%</td>
        </tr>
        <tr>
          <td :class="smallTextClass">%{{ labels.positions }}</td>
          <td v-if="0 !== allExchangesEquitiesValue" class="prop-value" :class="smallTextClass">{{ parseNumber(marketPrice / allExchangesEquitiesValue * 100) }}%</td>
          <td v-else class="prop-value" :class="smallTextClass">{{ parseNumber(0) }}%</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, default: null },
    windowWidth: { type: Number, required: true },
    userLanguage: { type: String, required: true },
    exchangeName: { type: String, required: true },
    labels: { type: Object, required: true },
    allExchangesEquitiesValue: { type: [Number, String], required: true },
    stockTypeResolver: { type: Function, required: true },
    positionsAmountResolver: { type: Function, required: true },
    tradePurchasePriceResolver: { type: Function, required: true },
    tradeMarketPriceResolver: { type: Function, required: true },
    percentDiffResolver: { type: Function, required: true },
    formatPrice: { type: Function, required: true },
    parseNumber: { type: Function, required: true }
  },
  computed: {
    smallTextClass() {
      return { 'xsmall-font-size': 1200 > this.windowWidth };
    },
    isBulgarian() {
      return 0 === 'BG'.localeCompare(this.userLanguage);
    },
    isEnglish() {
      return 0 === 'EN'.localeCompare(this.userLanguage);
    },
    purchasePrice() {
      return this.tradePurchasePriceResolver(this.item);
    },
    marketPrice() {
      return this.tradeMarketPriceResolver(this.item);
    },
    marketUnitPrice() {
      return this.item?.ldp
        ? this.item.ldp
        : this.item?.clp
          ? this.item.clp
          : this.item?.mp;
    },
    positionAmountDecimals() {
      return 2 === this.item?.stid ? 2 : 0;
    },
    returnValue() {
      return this.marketPrice - this.purchasePrice;
    },
    returnPercent() {
      return this.percentDiffResolver(this.marketPrice, this.purchasePrice);
    },
    returnClass() {
      return this.getReturnClass(this.returnValue);
    },
    returnPercentClass() {
      return this.getReturnClass(this.returnPercent);
    },
    returnPrefix() {
      return this.isPositiveValue(this.returnValue) ? "+" : "";
    },
    returnPercentPrefix() {
      return this.isPositiveValue(this.returnPercent) ? "+" : "";
    }
  },
  methods: {
    isPositiveValue(value) {
      return 0.005 <= parseFloat(value);
    },
    isNegativeValue(value) {
      return -0.005 >= parseFloat(value);
    },
    getReturnClass(value) {
      return {
        greenColor: this.isPositiveValue(value),
        redColor: this.isNegativeValue(value)
      };
    }
  }
};
</script>

<style scoped>
.prop-value {
  text-align: right;
  font-weight: bold;
}

.table td {
  font-size: 1rem;
  line-height: 1.35;
  padding: 0.6rem 0.5rem;
}

.greenColor {
  color: #74b21f;
}

.redColor {
  color: #ff0000;
}

.xsmall-font-size {
  font-size: 1rem;
}
</style>
